<template>
  <div class="container case-study-container">
      <div class="block-title-container" v-if="blockTitle != null || blockButton != null || block.show_filters">
          <h2 class="title" v-if="blockTitle" v-html="blockTitle"></h2>
          <div class="button-container" v-if="!block.show_filters && blockButton">
              <a class="btn" :href="blockButton.url" :target="blockButton.target" v-html="blockButton.title"></a>
          </div>
          <div class="filter-container" v-if="block.show_filters">
              <div class="select-wrap" :class="{'visible': productCategories.length>0}">
                <select class="products" v-if="productCategories.length > 0" v-model="selectedProductCategory" @change="filterChanged()">
                    <option name="product" value="">All Products</option>
                    <option v-for="(product, index) in productCategories" :key="index" name="product" :value="product.term_id" v-html="product.name"></option>
                </select>
              </div>
              <div class="select-wrap" :class="{'visible': markets.length>0}">
                <select class="markets" v-if="markets.length > 0" v-model="selectedMarket" @change="filterChanged()">
                    <option name="market" value="">All Markets</option>
                    <option v-for="(market, index) in markets" :key="index" :name="market" :value="market.term_id" v-html="market.name"></option>
                </select>
              </div>
          </div>
      </div>
      <div class="item-collection-list case-studies" v-if="caseStudies.length > 0">
          <div class="item" v-for="(item, index) in caseStudies" :key="index">
                <div class="image-container">
                    <img :src="item.acf_fields.primary_image.url" >
                </div>
                <div class="content-container">
                    <div class="top-title" v-html="item.acf_fields.content.top_title"></div>
                    <h2 class="title" v-html="item.post_title"></h2>
                    <div class="description" v-html="item.acf_fields.feature_settings.case_study_description"></div>
                    <div class="button-container">
                        <a class="hover-button orange" :href="item.permalink" v-html="getButtonText(item)"></a>
                    </div>
                </div>
          </div>
      </div>
      <div class="no-items" ref="emptyList" style="display: none;">
          <h3 class="roboto-mono message">No case studies found that match this filter.</h3>
      </div>
      <div class="ajax-spinner" v-if="isLoading">
          <i class="fas fa-spinner fa-spin float-right tx-dark-gray"></i>
      </div>
      <div class="load-more-container" v-if="isShowLoadMore">
          <a class="btn tx-dark-gray float-right" href="javascript:void(0);" @click="loadMore()">Load more <i class="fas fa-chevron-down"></i></a>
      </div>
  </div>
</template>

<script>
import caseStudyApi from '../../case-study-api';
import listFilterApi from '../../list-filter-api';
export default {
    props: {
      block: {
          type: Object,
          required: true
      },
    },
    data() {
        return {
            caseStudies:[],
            markets: [],
            productCategories: [],
            page: 1,
            isLoading: false,
            isShowLoadMore: false,
            selectedProductCategory: "",
            selectedMarket: ""
        }
    },
    mounted() {
        this.page = 1;
        this.loadMore();

        if (this.block.show_filters) {
            this.loadFilters();
        }
    },
    computed: {
        blockTitle: function() {
            return this.block.title;
        },
        blockButton: function() {
            return this.block.button;
        },
        selectionOptions: function() {
            return this.block.case_study_selection_options;
        },
        getCasesBy: function() {
            this.selectionOptions.get_items_by;
        }
    },
    methods: {
        loadMore: function() {
            this.isLoading = true;
            this.isShowLoadMore = false;
            this.$refs.emptyList.style.display = "none";
            caseStudyApi.loadCaseStudies(this.selectionOptions, this.selectedProductCategory, this.selectedMarket, this.page)
                .then(response => {
                    if (typeof(response) != 'undefined') {
                        let data = response.data.payload;
                        if (typeof(data.items) != 'undefined') {
                            this.caseStudies = this.caseStudies.concat(data.items);
                            this.isShowLoadMore = this.selectionOptions.show_load_more && data.has_more;
                            this.page++;

                            if (this.caseStudies.length == 0) {
                                this.$refs.emptyList.style.display = "block";
                            } else {
                                this.$refs.emptyList.style.display = "none";
                            }
                        }
                    } else {
                        this.isShowLoadMore = true;
                    }
                    this.isLoading = false;
                });
        },
        loadFilters: function() {
            listFilterApi.getFilters('md_case_study')
                .then(response => {
                    if (typeof(response) != 'undefined') {
                        let data = response.data.payload;
                        this.markets = data.markets;
                        this.productCategories = data.productCategories;
                    }
                });
        },
        filterChanged: function() {
            // Clear items
            this.caseStudies = [];
            // Reset page
            this.page = 1;

            this.loadMore();
        },
        getButtonText(item) {
            var text = item.acf_fields.feature_settings.button_text_override;
            if (text.length == 0) {
                text = "Continue to case study"
            } 
            return text;
        }

    }
}
</script>

<style>
.ajax-spinner {
    padding:20px;
    padding-bottom: 40px;
}
</style>